export enum UnlockUserReasonEnum {
  UnlockedBySystem,
  RestorePermissions
}
